module.exports = __webpack_public_path__ + "img/sticker.79bc6533.svg";